import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { handleSignout } from './Logout';

const BASE_URL = process.env.REACT_APP_BASEURL;

const instance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true
});

const useApiRequest = () => {
    const getErrorMessage = (error) => {

        if (error?.response?.data?.message) {
            return error.response.data.message;
        }

        if (error?.message) {
            return error.message;
        }

        return "An unknown error occurred. Please try again.";
    };
    const apiRequest = async (method, url, payload = null, query = {}, customHeaders = {}, isSendingMessage = true, snakeBar = true) => {

        try {
            const response = await instance({
                method,
                url,
                ...(payload !== null && payload !== undefined ? { data: payload } : {}),
                params: query,
                headers: {
                    ...customHeaders,
                },
            });

            if (isSendingMessage) {
                if (response?.data?.status === true || response?.data?.success === true) {
                    snakeBar && enqueueSnackbar(response?.data?.message || "Response is successful!", { variant: 'success', autoHideDuration: 2000 });
                }
                else if (response?.status_code === "1000") {
                    snakeBar && enqueueSnackbar(response?.status_message || "Response is successful!", { variant: 'success', autoHideDuration: 2000 });
                }
                else {
                    snakeBar && enqueueSnackbar(response?.data?.message || "Response is failed!", { variant: 'error', autoHideDuration: 2000 });
                }
            }
            return { data: response?.data, error: null };
        }

        catch (error) {

            const message = getErrorMessage(error);

            if (error?.response?.status === 401) {
                snakeBar && enqueueSnackbar(message, { variant: 'error', autoHideDuration: 2000 });
                handleSignout();
            }
            else if (error?.response?.status === 409) {
                console.log(error);
                snakeBar && enqueueSnackbar(message, { variant: 'error', autoHideDuration: 2000 });
                return { data: null, error: error?.response ? error?.response?.data : error?.message };
            }
            else {
                console.log(error);
                snakeBar && enqueueSnackbar(message, { variant: 'error', autoHideDuration: 2000 });
                return { data: null, error: error?.response ? error?.response?.data : error?.message };
            }
        }
    };

    return apiRequest;
};

export default useApiRequest;